/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q2Inputs */

const en_to_typescript_faq_q2 = /** @type {(inputs: To_Typescript_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I customize the generated interface names?`)
};

const ko_to_typescript_faq_q2 = /** @type {(inputs: To_Typescript_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성된 인터페이스 이름을 변경할 수 있나요?`)
};

const ja_to_typescript_faq_q2 = /** @type {(inputs: To_Typescript_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成されたインターフェース名を変更できますか？`)
};

/**
* | output |
* | --- |
* | "Can I customize the generated interface names?" |
*
* @param {To_Typescript_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q2 = /** @type {((inputs?: To_Typescript_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q2(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q2(inputs)
	return ja_to_typescript_faq_q2(inputs)
});